// extracted by mini-css-extract-plugin
export var inline = "_ut-0";